import { type Ref, computed, watch } from 'vue'
import type { ColumnFiltersState } from '@tanstack/vue-table'
import type { List } from '../types/list'
import type { Elemental, ElementalTypeEnum } from '../types/elemental'
import { resolveValueByPath } from '~~/src/utils/resolve-value-by-path'
interface Props {
  list: Elemental | List
  elementals: Elemental[] | null
  filters?: Ref<ColumnFiltersState>
}

export function useElementalListFilter(
  props: Ref<Props>,
  query: Ref<string>,
  filters?: Ref<ColumnFiltersState>,
  countList?: (id: string, type: ElementalTypeEnum, value: number) => void,
) {
  const filteredElementals = computed(() => {
    if (!props.value.elementals || !Array.isArray(props.value.elementals))
      return []

    let filtered = props.value.elementals

    if (query.value?.trim()) {
      const q = query.value.toLowerCase()
      filtered = filtered.filter(item =>
        item.title.toLowerCase().includes(q)
        || item.id.toString().toLowerCase().includes(q),
      )
    }

    if (filters?.value?.length) {
      filters.value.forEach((filter) => {
        filtered = filtered.filter((item) => {
          const value = resolveValueByPath(item, filter.id)
          return value?.toString().toLowerCase().includes(filter.value?.toString().toLowerCase() ?? '')
        })
      })
    }

    return filtered
  })

  const showList = computed(() => {
    const q = query.value.toLowerCase()
    return (
      q === ''
      || (filteredElementals.value && filteredElementals.value.length > 0)
      || props.value.list.title.toLowerCase().includes(q)
    )
  })

  if (countList) {
    watch(
      () => [query.value, filteredElementals.value] as const,
      ([q, data]) => {
        if (!data)
          return

        let count = data.length
        if (
          q.trim() === ''
          || props.value.list.title.toLowerCase().includes(q.toLowerCase())
          || `${props.value.list.id}`.includes(q.toLowerCase())
        )
          count++

        countList(props.value.list.id, props.value.list.elementalTypeId!, count)
      },
      { immediate: true },
    )
  }

  return {
    filteredElementals,
    showList,
  }
}
